<div class="page-header">
  <div class="subtitle">
    <span [innerHTML]="findingsSubtitlePath | labelsProvider"></span>
    <img
      class="icon-field"
      src="assets/images/common/info.svg"
      height="16px"
      [matTooltip]="findingsTooltipLabelPath | labelsProvider"
      matTooltipPosition="above"
    />
  </div>
</div>

<div class="scollable-tables">
  <app-enterprise-ai-findings></app-enterprise-ai-findings>
</div>
